import { useEffect } from "react";
import CartScreen from "../features/cart/CartScreen";
import { useGlobalContext } from "../context/GlobalContext";

const CartPage = () => {
  const { setSearch } = useGlobalContext();

  useEffect(() => {
    return () => {
      setSearch("");
    };
  }, []);

  return (
    <>
      <CartScreen />
    </>
  );
};

export default CartPage;
